import axios from "axios";
import { LOCAL_TOKEN } from "../utils/storage";

// Servicio para logs

export const toggleSyncSwitch = (data = {}) => {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}logs/toggle-sync-switch`,
    data,
  });
};

export const validateSyncCredentials = (data = {}) => {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}logs/validate-sync-credentials`,
    data,
  });
};

export const editStructureIds = (data = {}) => {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}logs/edit-structure-ids`,
    data,
  });
};

export const assignDivisions = (data = {}) => {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}logs/assign-divisions`,
    data,
  });
};

export const validateUrlPerformance = (data = {}) => {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/validate-url-performance`,
    data,
  });
};